import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Import components
import NumberWidget from './NumberWidget';

class NumberWidgetContainer extends Component {
    constructor() {
        super();

        // Set initial state
        this.state = {
            loading: true,
            value: undefined
        }
    }

    // // Fetch data when the component is added
    // component() {
    //     this.setState({loading: false})
    // }

    render() {
        return (
            // Render the number widget
            <NumberWidget heading={this.props.heading} colspan={this.props.colspan} rowspan={this.props.rowspan} sub={this.props.sub} value={this.props.value} loading={this.props.loading} stats={this.props.stats} icon={this.props.icon}/>
        );
    }
}

// Enforce the type of props to send to this component
NumberWidgetContainer.propTypes = {
    heading: PropTypes.string,
    colspan: PropTypes.number,
    rowspan: PropTypes.number
}

export default NumberWidgetContainer;